// extracted by mini-css-extract-plugin
module.exports = {"container":"_1xW7CUWaAL-bke4xVeN46y","title":"sca6C3o59Dce0z95-7TkN","absolute":"V1JK5Ip1Ab1gqn4DNMIU6"};